// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qPSD","col":"styles_col__1nbsY"};